import axios from "axios";
import settings from "../../../../utils/settings";

const url = `${settings.accountsUrl}api/admin/agreement`;

export const addStaticPage = (data) => axios.post(`${url}`, data);



// WEBPACK FOOTER //
// ./src/views/pages/static-pages/requests/addStaticPage.js